import { useMemo } from 'react';
import { Box } from '@mui/material';
import { MultiSearchSelect } from '../../../../shared/components/multiSearchSelect';
import { useDispatch, useSelector } from '../../../../shared/hooks/redux';
import { useGetCategoriesQuery } from '../../../../shared/redux/rental';
import { setMainCategories, useEquipmentOwners } from '../../../../core/redux/leftFilterState';
import { labelSort } from '../../../../shared/logic/functions';

export const MainCategoryFilter = () => {
  const owners = useEquipmentOwners();
  const dispatch = useDispatch();

  const {
    mainCategories: leftMainCat,
    subCategories: leftSubCat,
  } = useSelector((s) => s.leftFilterState.equipment);
  const { data, isLoading } = useGetCategoriesQuery({ includeSubCategories: true, owners });

  const mainCategories = useMemo(
    () => Array.from(
      new Set(data
        ?.filter((m) => leftSubCat.length === 0 || m.subCategories.some((sc) => leftSubCat.some((lsc) => lsc.label === sc)))
        ?.map((m) => m.name)),
    ).map((m) => ({ id: m, label: m }))
      .sort(labelSort),
    [data, leftSubCat],
  );

  return (
    <Box minWidth="200px" flex={1}>
      <MultiSearchSelect
        label="Hovedkategori"
        size="small"
        value={leftMainCat}
        loading={isLoading}
        onChange={(l) => dispatch(setMainCategories(l))}
      >
        {mainCategories}
      </MultiSearchSelect>
    </Box>
  );
};
